import { cn } from "@modules/lib/utils"

const TOTAL_STEPS = 2

export function CoachCategoryFormStepper({ step }: { step: 1 | 2 }) {
  return (
    <div className="flex gap-2">
      {Array.from({ length: TOTAL_STEPS }, (_, index) => {
        const stepNum = index + 1
        const isActive = stepNum === step
        const isCompleted = stepNum < step
        return (
          <div
            key={stepNum}
            className={cn(
              "h-4 w-14 rounded-full transition-all",
              isActive && "bg-interactive-background-primary-faded-highlighted",
              isCompleted && "bg-interactive-background-primary-faded",
              !isActive && !isCompleted && "bg-surface-background-secondary",
            )}
          />
        )
      })}
    </div>
  )
}
